module.exports = __webpack_public_path__ + "static/img/QRCode.eb32530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QRCode.png
// module id = LGPz
// module chunks = 1